import { NotificationDetails } from '@evidentid/tprm-portal-lib/models/activity-history';

const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
    NEW: 'New',
    NON_COMPLIANT: 'Non Compliant',
    EXPIRING: 'Expiring',
    NEW_ENTITY_BODY: 'New Entity',
    COMPLIANT: 'Compliant',
};

export function getNotificationTypeLabel(
    notificationType: NotificationDetails['notificationType'] | null | undefined,
): string {
    if (!notificationType) {
        return '';
    }
    return NOTIFICATION_TYPE_LABELS[notificationType] || notificationType;
}

export function getNotificationPrefix(
    details: Pick<NotificationDetails, 'notificationType' | 'verificationType' | 'notificationOperation'>,
): string {
    const label = getNotificationTypeLabel(details.notificationType ?? details.verificationType);
    if (details.notificationOperation !== 'REMINDER') {
        return label;
    }
    return label ? `${label} Reminder` : 'Reminder';
}
